export default __webpack_public_path__ + "static/media/army_22.55cd4c9c.jpg";